import { BRAND, whatsappUrl } from "@/lib/site-data";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href={whatsappUrl()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`WhatsApp üzerinden Epersonel ile iletişime geçin: ${BRAND.contact.phone}`}
      data-testid="whatsapp-floating-button"
      className="fixed z-30 inline-flex items-center gap-2 py-2.5 pl-2.5 pr-3 sm:py-3 sm:pl-3 sm:pr-4 rounded-full text-white font-semibold shadow-lg transition-transform hover:-translate-y-0.5"
      style={{
        backgroundColor: "#25D366",
        boxShadow:
          "0 12px 32px -8px rgba(37,211,102,0.55), 0 0 0 1px rgba(255,255,255,0.06)",
        bottom: "max(1rem, env(safe-area-inset-bottom))",
        right: "max(1rem, env(safe-area-inset-right))",
      }}
    >
      <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5" />
      <span className="hidden md:inline text-sm">WhatsApp'tan Yaz</span>
      <span className="md:hidden text-xs">WhatsApp</span>
    </a>
  );
}
